<template>
  <v-app class="custom_bg">
    <v-container fill-height>
      <v-row>
        <v-col cols="12" md="12" class="text-center">
          <p class="text-h2">
            Your have <strong>{{ day }} </strong>days left on your subscription
          </p>
        </v-col>
        <v-col cols="12" md="12" class="text-center">
          <v-btn color="secondary" class="text-capitalize" large :href="getSub">
            Subscribe Now!
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    day: "",
  }),
  computed: {
    ...mapGetters(["getUser", "getSub", "currentUser"]),
  },
  methods: {
    fetchSub() {
      fetch("https://receipt.drecsoft.com/api/v1/business/user-subscription", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.currentUser}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          this.day = res.data.day;
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.fetchSub();
  },
};
</script>

<style scoped>
.custom_bg {
  background: #f6f7ff;
}
</style>